<button type="button" class="document-card" (click)="onPress()">
  <span class="document-card__title">{{ title() }}</span>
  <img
    class="document-card__icon"
    src="assets/img/icon-document-pdf.svg"
    alt=""
    width="144"
    height="151"
    loading="lazy"
  />
</button>
